var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteDollarBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.673 21.6465H16.9375V25.334H18.673V21.6465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 16H13.1719V19.7158H14.9375V16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4971 9.9366C19.1122 8.05425 20.2642 3.80578 20.2642 2.2679C20.2642 -0.981045 18.3272 3.09613 15.9385 3.09613C13.546 3.09613 11.6129 -1.02246 11.6129 2.2679C11.6129 3.83213 12.7969 8.19354 14.459 10.0288C9.54981 11.4218 5.67969 18.4881 5.67969 24.6999C5.67969 30.1926 10.3009 31.0321 15.9987 31.0321C21.6966 31.0321 26.3159 30.1173 26.3159 24.6999C26.3159 19.0415 22.5437 11.1451 17.4971 9.9366ZM20.763 25.4999H18.8806V27.3521H16.9983V29.2928H14.9992V27.3521H13.1169V25.4999L13.1413 25.4698H11.2345V23.4707H13.2053V25.3907L13.2355 25.3531H15.0011V21.7051H13.1752V19.8528H11.2044V15.9714H13.1752V14.059H14.9992V12.1183H16.9983V14.059H18.8806V15.9413H20.7329V17.9404H18.762V16.0185L18.7319 16.0298H16.9964V19.706H18.9089V21.6185H20.7611V25.4999H20.763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDollarBag);
export default __webpack_public_path__ + "static/media/whiteDollarBag.92d4c07fa8eb0fa9a6dbfe8da3d79732.svg";
export { ForwardRef as ReactComponent };